
<template>
  <div v-if="!rail" class="sidebar-bottom">
    <div class="sidebar-help-card">
      <div class="help-icon">
        <v-icon icon="mdi-headset" size="22" />
      </div>

      <div class="help-title">
        Need assistance?
      </div>

      <div class="help-description">
        Get help managing your bus operations.
      </div>

      <v-btn
        variant="flat"
        color="primary"
        rounded="lg"
        block
        size="small"
        class="help-button"
        @click="navigate('/support')"
      >
        Get Support
        <v-icon icon="mdi-arrow-right" end size="16" />
      </v-btn>
    </div>

    <div class="sidebar-version">
      <v-icon icon="mdi-shield-check-outline" size="15" />
      <span>RouteBus Admin</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "NeedHelp",

  props: {
    rail: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    navigate(route) {
      if (this.$route.path !== route) {
        this.$router.push(route);
      }
    },
  },
};
</script>

<style scoped>
.sidebar-bottom {
  flex: 0 0 auto;
  margin-top: auto;
  padding: 14px 4px;
  background: rgb(var(--v-theme-rb-sidebar-bg));
}

.sidebar-help-card {
  padding: 15px 13px;
  border: 1px solid rgb(var(--v-theme-rb-sidebar-line));
  border-radius: 14px;
  background: rgb(var(--v-theme-rb-primary-light));
  transition: background-color 0.2s ease, border-color 0.2s ease;
}

.help-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  margin-bottom: 12px;
  border: 1px solid rgb(var(--v-theme-rb-sidebar-line));
  border-radius: 11px;
  color: rgb(var(--v-theme-primary));
  background: rgb(var(--v-theme-surface));
}

.help-title {
  margin-bottom: 6px;
  color: rgb(var(--v-theme-rb-sidebar-text));
  font-size: 14px;
  font-weight: 700;
  line-height: 1.5;
}

.help-description {
  margin-bottom: 13px;
  color: rgb(var(--v-theme-rb-sidebar-muted));
  font-size: 12px;
  font-weight: 400;
  line-height: 1.6;
}

.help-button {
  min-height: 36px;
  background: rgb(var(--v-theme-primary)) !important;
  color: rgb(var(--v-theme-on-primary)) !important;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: none;
}

.help-button:hover {
  background: rgb(var(--v-theme-rb-primary-hover)) !important;
}

.sidebar-version {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding-top: 14px;
  color: rgb(var(--v-theme-rb-sidebar-muted));
  font-size: 11px;
  font-weight: 500;
}

.sidebar-version .v-icon {
  color: rgb(var(--v-theme-rb-sidebar-muted));
}

@media (prefers-reduced-motion: reduce) {
  .sidebar-help-card {
    transition: none;
  }
}
</style>